import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from './Icon';
import { usePermissions } from '../hooks/usePermissions';
import { getSidebarRoutes } from '../config/roles';
import type { User } from '../types/auth';

interface SidebarProps {
  isOpen: boolean;
  closeSidebar: () => void;
}

// Mapeo de iconos para las rutas
const iconMap: Record<string, string> = {
  dashboard: 'dashboard',
  'dashboard-deals': 'dashboard',
  leads: 'users',
  deals: 'users',
  contacts: 'users',
  imports: 'upload',
  // usuarios: 'users',
  // funcionarios: 'briefcase',
  // eventos: 'calendar',
  // accesos: 'key',
  // reports: 'chart-bar',
  // 'call-center': 'phone',
  // 'open-doors': 'door-open',
  settings: 'settings'
};

// const quickActions = [
// { to: '/admin/open-doors', icon: 'door', label: 'Abrir Carril' },
// { to: '/admin/funcionarios', icon: 'search', label: 'Buscar Funcionarios' },
// { to: '/admin/call-center', icon: 'search', label: 'Call Center' },
// { to: '/admin/new-user', icon: 'plus', label: 'Nuevo Usuario' }
// ];

export const Sidebar: React.FC<SidebarProps> = ({ isOpen, closeSidebar }) => {
  const { userRole } = usePermissions();
  const userData: User | null = (() => {
    try {
      const userStr = localStorage.getItem("user");
      return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
      return null;
    }
  })();



  // Obtener rutas permitidas para el sidebar basadas en el rol del usuario
  const allowedRoutes = userRole ? getSidebarRoutes(userRole) : [];

  return (
    <>
      {/* Overlay para móvil */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/30 backdrop-blur-sm bg-opacity-50 z-20 lg:hidden"
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed lg:static inset-y-0 left-0 z-30 w-64 
        bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700
        transform transition-transform duration-300 ease-in-out flex flex-col
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <div className="flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
          <div className="flex items-center space-x-3">
            <div className="w-25 h-10 bg-white  rounded-xl flex items-center justify-center">
              <img
                src="/iaen_logo.png"
                alt="Dashboard"
                className="w-auto object-contain"
              />
            </div>

          </div>

          <button
            onClick={closeSidebar}
            className="lg:hidden p-2 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
            aria-label="Close sidebar"
          >
            <Icon name="close" className="w-4 h-4" />
          </button>
        </div>

        <nav className="mt-8 px-4 flex-1 overflow-y-auto">
          <h3 className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2">
            Navegación
          </h3>
          <ul className="space-y-2 pb-4">
            {allowedRoutes.map((route) => (
              <li key={route.path}>
                <NavLink
                  to={`/admin/${route.path}`}
                  onClick={closeSidebar}
                  className={({ isActive }) => `
                    flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-150
                    ${isActive
                      ? 'bg-primary/10 text-primary  dark:bg-primary/20 dark:text-primary/40'
                      : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                    }
                  `}
                >
                  <Icon name={iconMap[route.path] || 'circle'} className="w-5 h-5 mr-3" />
                  {route.title}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="border-t border-gray-200 dark:border-gray-700 pt-4">
            {/* <h3 className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2">
              Acciones Rápidas
            </h3> */}

            {/* <ul className="space-y-1">
              {quickActions.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    onClick={closeSidebar}
                    className={({ isActive }) => `
                    flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-150
                    ${isActive
                        ? 'bg-primary/10 text-primary  dark:bg-primary/20 dark:text-primary/50'
                        : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                      }
                  `}
                  >
                    <Icon name={item.icon} className="w-4 h-4 mr-3 " />
                    <span className="text-xs font-medium">{item.label}</span>
                  </NavLink>
                </li>
                // <li key={action.id}>
                //   <button
                //     onClick={() => {
                //       // Aquí puedes agregar la lógica para cada acción
                //       closeSidebar();
                //     }}
                //     className="w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-left transition-colors duration-200 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-200"
                //   >
                //     <Icon
                //       name={action.icon}
                //       className="w-4 h-4"
                //     />
                //     <span className="text-xs font-medium">{action.name}</span>
                //   </button>
                // </li>
              ))}
            </ul> */}
          </div>
        </nav>

        <div className="flex-shrink-0 p-4 border-t border-gray-200 dark:border-gray-700">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-gray-300 dark:bg-gray-600 rounded-full"></div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                {userData?.name}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                {userData?.email}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};